<template>
  <div class="header container bg-white mx-auto p-0" :id="route.name?.toString()">
    <div class="bg-white">
      <div class="container mx-auto pt-6 pb-4 sticky-padding-small">
        <div class="flex items-center justify-between h-16">
          <NuxtLink to="/"><img class="logo" src="~/assets/images/logo_spring_green.png" alt="Spring Green Logo" loading="lazy" /></NuxtLink>
          <client-only>
            <div class="flex items-center justify-end flex-wrap h-16">
              <span class="font-semibold uppercase" v-if="bLocation"> {{ bLocation }} </span>
              &nbsp;
              <a class="text-gray-500 font-bold" :href="contactPhoneUrl" v-if="contactPhone">{{ displayContactPhone }}</a>
            </div>
          </client-only>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script setup lang="ts">
import { formatPhoneNumber, getPhoneHref } from "~/utils/phone";

const route = useRoute();

const props = defineProps({
  bLocation: String,
  contactPhone: String,
});

const displayContactPhone = computed(
  () => formatPhoneNumber(props.contactPhone) ?? props.contactPhone,
);
const contactPhoneUrl = computed(() => getPhoneHref(props.contactPhone) ?? undefined);
</script>
  
<style scoped>
.header {
  border-bottom: 1px solid #b9b9b9;
  position: relative;
  z-index: 200;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #517185;
  opacity: 0.9;
  /* Firefox */
}

.mobile a {
  font-weight: 600;
  display: block;
}

.logo {
  width: 260px;
  aspect-ratio: 762 / 183;
}

@media (max-width: 1180px) {
  .logo {
    width: 180px;
    aspect-ratio: 762 / 183;
  }
}

@media (max-width: 1120px) AND (min-width: 1024px) {
  .menu a {
    font-size: 13px;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}

@media (max-width: 640px) {
  .logo {
    width: 120px;
  }
}

/* Mobile Sticky styles*/
@media screen and (max-width: 1023px) {
  .header {
    position: sticky;
    top: -1px;
    transition: all .2s ease-in-out;
  }

  .header.is-sticky .sticky-padding-small {
    padding: .25em 3%;
  }

  .header .sticky-padding-small {
    transition: all .2s ease-in-out;
  }
}
</style>
